import { useEffect, useMemo, useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { XMarkIcon, PlusIcon } from "@heroicons/react/24/outline";

import VehicleTable from "../../components/vehicles/VehicleTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useContactSingle from "../../data/useContactsSingle";
import { IVehicle, PartsStatusValues } from "../../models/Vehicle";
import { LinkButton } from "../../components/shared/Inputs/LinkButton";
import useCustomerDetails from "../../data/useCustomerDetails";
import VehicleStats from "../../components/vehicles/VehicleStats";
import CreateVehicle from "./CreateVehicle";


export default function VehicleList() {
  const { features } = useCustomerDetails();
  const location = useLocation();
  const { setInfo } = usePageNameContext();
  // const { vehicles: allVehicles } = useVehicles();
  const { contact } = useContactSingle(location.state ? location.state?.filter?.contactId ?? "" : "");
  const [vehicles, setVehicles] = useState<IVehicle[] | undefined>(undefined);
  const [clickedFilter, setClickedFilter] = useState<any | undefined>(undefined);


  const hasLeads = useMemo(() => {
    return features.data?.data?.find((f) => f.name === "Lead Management");
  }, [features.data]);

  useEffect(() => {
    if (location.state?.filter && !contact.isLoading) {
      let foundContact = contact.data;
      setInfo({
        name: `Vehicles for ${foundContact?.data.fullname}`,
        desc: "View and manage filtered vehicles here",
      });
    } else {
      setInfo({
        name: "Vehicles",
        desc: "View and manage all vehicles here",
      });
    }
  }, [location, contact.isLoading]);

  return (
    <div className="mt-4 flex flex-col gap-4">
      <VehicleStats />

      <div className="flex items-center justify-between">
        <div>
          {location.state?.filter && (
            <Link
              to={"/vehicles"}
              replace={true}
              state={undefined}
              className="inline-flex items-center rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-primary-700"
            >
              <XMarkIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
              Clear filter
            </Link>
          )}
        </div>

        <LinkButton
          to={hasLeads ? "/leads/create-multiple" : "/vehicles/create"}
          label={hasLeads ? "Create Lead" : "Create Vehicle"}
          classes="inline-flex items-center"
        >
          <PlusIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
        </LinkButton>
      </div>

      <VehicleTable additionalBody={{}} />
    </div>
  );
}
